import React, { useState, useRef, useEffect, Fragment } from "react";
import Select from "react-select";
import {
  CaretDownSolidIcon,
  CaretUpSolidIcon,
  CrossIcon,
} from "../../../../assets/icons";
import Pagination from "../../../shared/common/pagination";
import SelectPageSize from "../../../shared/common/pageSizeDropdown";
import SchoolDetail from "../schoolDetail";
import { getStateAll } from "../../../../api/subject.service";
import {
  deleteSchoolById,
  getMiniCRMDistricts,
  getMiniCRMSchools,
  updateSchool,
} from "../../../../api/miniCrm.service";
import { IReactSelect } from "../../../../model/interface/keyValuePair";
import { XIcon } from "@heroicons/react/outline";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../../shared/loader/loader";
import { Dialog, Transition } from "@headlessui/react";
import { updateNWEASchoolId } from "../../../../api/school.service";

const SchoolPupUp: React.FC<any> = ({
  closeSchoolModal,
  mapSchool,
  userId,
  unmappedNWEASchools,
}: {
  closeSchoolModal: () => void;
  mapSchool: () => void;
  userId: number;
  unmappedNWEASchools: Array<any>;
}) => {
  const defaultSelect = { label: "", value: 0 };
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [sortCol, setSortCol] = useState<string>("");
  const [sortByDesc, setSortByDesc] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [selectedState, setSelectedStates] = useState<IReactSelect>();
  const [selectedDistrict, setSelectedDistrict] =
    useState<IReactSelect>(defaultSelect);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [schools, setSchools] = useState<Array<any>>([]);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRegion, setSelectedRegion] = useState<any>({
    label: "",
    value: "",
  });
  const [school, setSchool] = useState<string>("");
  const [editSchool, setEditSchool] = useState<any>();
  const [editFields, setEditFields] = useState<any>();
  const [deleteSchool, setDeleteSchool] = useState<any>();
  const [editSchoolName, setEditSchoolName] = useState<string>();
  const [editSelectedState, setEditSelectedStates] = useState<IReactSelect>();
  const [editSelectedDistrict, setEditSelectedDistrict] =
    useState<IReactSelect>(defaultSelect);
  const [editCity, setEditCity] = useState<string>();
  const [editZip, setEditZip] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    getSchools();
  }, []);

  useEffect(() => {
    if (pageNumber === 1) {
      getSchools();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  useEffect(() => {
    if (isLoaded) {
      getSchools();
    }
  }, [pageNumber, sortByDesc]);

  const getSchools = async (isReset?) => {
    setLoading(true);
    let params = {};
    if (isReset) {
      params = {
        stateId: 0,
        region: "",
        districtId: 0,
        districtName: "",
        schoolName: "",
        orderByColumn: sortCol,
        sortDir: sortByDesc ? "asc" : "desc",
        pageSize: 10,
        pageNumber: 1,
      };
    } else {
      params = {
        stateId: selectedState?.value,
        region: selectedRegion?.value,
        districtId: selectedDistrict?.value,
        schoolName: school,
        orderByColumn: sortCol,
        sortDir: sortByDesc ? "asc" : "desc",
        pageSize: pageSize,
        pageNumber: pageNumber,
      };
    }

    setSchools(unmappedNWEASchools);
    setTotalPages(
      Math.ceil(unmappedNWEASchools.length / (isReset ? 10 : pageSize))
    );
    setTotalRecords(unmappedNWEASchools.length);
    setLoading(false);
  };

  const handleSortBy = (column: string) => {
    setSortByDesc(!sortByDesc);
    setSortCol(column);
  };

  const handleModal = (school) => {
    setEditSchool(school);
    setModalOpen(!modalOpen);
  };

  const resetClickHandler = () => {
    setSelectedStates(defaultSelect);
    setSelectedRegion({ label: "", value: "" });
    setSelectedDistrict(defaultSelect);
    setSchool("");
    getSchools(true);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
    const form: any = document.getElementById("users_form");
    if (form) form.reset();
  };

  const onUpdate = async (schoolId: number, nweaId: string) => {
    setLoading(true);
    try {
      const resp = await updateNWEASchoolId(schoolId, nweaId, userId);
      setLoading(false);
      if (resp) {
        toast.success("School updated successfully");
        mapSchool();
      } else {
        toast.error("School update failed");
      }
    } catch (e) {
      toast.error("School update failed");
      setLoading(false);
    }
  };

  const [open, setOpen] = useState(true);
  return (
    <>
      <div className="w-full justify-center items-center flex my-auto h-5/6 fixed inset-0 z-50 outline-none focus:outline-none">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <div className="relative h-full w-5/6 my-6 mx-auto">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className="relative p-6 flex-auto">
              <div className="flex">
                <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    onClick={closeSchoolModal}
                    className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text-primary"
                  >
                    <CrossIcon className="w-6 h-6"></CrossIcon>
                  </button>
                </div>
                <div className="flex">
                  <h1 className="text-gray-700 font-semibold text-xl">
                    School Mapping
                  </h1>
                </div>
              </div>

              <form id="users_form" className="p-3">
                {loading && <Loader />}

                <div id="dataContainer" className="mt-4 border-t pt-6">
                  <div className="flex flex-col mt-1">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                          <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-primary-color">
                              <tr>
                                <th
                                  scope="col"
                                  className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                                >
                                  <span className="flex">
                                    School Name
                                    <span className="cursor-pointer">
                                      {sortByDesc &&
                                      sortCol === "schoolName" ? (
                                        <CaretUpSolidIcon
                                          onClick={() =>
                                            handleSortBy("schoolName")
                                          }
                                          className="w-5 h-5"
                                        ></CaretUpSolidIcon>
                                      ) : (
                                        <CaretDownSolidIcon
                                          onClick={() =>
                                            handleSortBy("schoolName")
                                          }
                                          className="w-5 h-5"
                                        ></CaretDownSolidIcon>
                                      )}
                                    </span>
                                  </span>
                                </th>

                                <th
                                  scope="col"
                                  className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                                >
                                  <span className="flex">
                                    District
                                    <span className="cursor-pointer">
                                      {sortByDesc && sortCol === "district" ? (
                                        <CaretUpSolidIcon
                                          onClick={() =>
                                            handleSortBy("district")
                                          }
                                          className="w-5 h-5"
                                        ></CaretUpSolidIcon>
                                      ) : (
                                        <CaretDownSolidIcon
                                          onClick={() =>
                                            handleSortBy("district")
                                          }
                                          className="w-5 h-5"
                                        ></CaretDownSolidIcon>
                                      )}
                                    </span>
                                  </span>
                                </th>

                                <th
                                  scope="col"
                                  className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                                >
                                  <span className="flex">
                                    City
                                    <span className="cursor-pointer">
                                      {sortByDesc && sortCol === "city" ? (
                                        <CaretUpSolidIcon
                                          onClick={() => handleSortBy("city")}
                                          className="w-5 h-5"
                                        ></CaretUpSolidIcon>
                                      ) : (
                                        <CaretDownSolidIcon
                                          onClick={() => handleSortBy("city")}
                                          className="w-5 h-5"
                                        ></CaretDownSolidIcon>
                                      )}
                                    </span>
                                  </span>
                                </th>

                                <th
                                  scope="col"
                                  className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                                >
                                  <span className="flex">
                                    State
                                    <span className="cursor-pointer">
                                      {sortByDesc && sortCol === "state" ? (
                                        <CaretUpSolidIcon
                                          onClick={() => handleSortBy("state")}
                                          className="w-5 h-5"
                                        ></CaretUpSolidIcon>
                                      ) : (
                                        <CaretDownSolidIcon
                                          onClick={() => handleSortBy("state")}
                                          className="w-5 h-5"
                                        ></CaretDownSolidIcon>
                                      )}
                                    </span>
                                  </span>
                                </th>

                                <th
                                  scope="col"
                                  className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                                >
                                  <span className="flex">
                                    Zip
                                    <span className="cursor-pointer">
                                      {sortByDesc && sortCol === "zip" ? (
                                        <CaretUpSolidIcon
                                          onClick={() => handleSortBy("zip")}
                                          className="w-5 h-5"
                                        ></CaretUpSolidIcon>
                                      ) : (
                                        <CaretDownSolidIcon
                                          onClick={() => handleSortBy("zip")}
                                          className="w-5 h-5"
                                        ></CaretDownSolidIcon>
                                      )}
                                    </span>
                                  </span>
                                </th>
                                <th
                                  scope="col"
                                  className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                                >
                                  NWEA Id
                                </th>
                                <th className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {schools?.map((school, i) => (
                                <tr
                                  key={i}
                                  className={`align-top ${
                                    i % 2 === 0 ? "bg-white " : "bg-gray-100"
                                  }`}
                                >
                                  <td className=" px-3 py-2  text-sm text-left font-normal relative">
                                    <button
                                      className="text-indigo-500"
                                      type="button"
                                      onClick={() => {
                                        handleModal(school);
                                      }}
                                    >
                                      {school.name}
                                    </button>
                                  </td>
                                  <td className=" px-3 py-2  text-sm text-left font-normal relative">
                                    {school.districtName}
                                  </td>
                                  <td className=" px-3 py-2  text-sm text-left font-normal relative">
                                    {school.city}
                                  </td>
                                  <td className=" px-3 py-2  text-sm text-left font-normal relative">
                                    {school.stateName}
                                  </td>
                                  <td className=" px-3 py-2  text-sm text-left font-normal relative">
                                    {school.zipCode}
                                  </td>
                                  <td className=" px-3 py-2  text-sm text-center font-normal relative">
                                    {school.nweaId}
                                  </td>
                                  <td className=" px-3 py-2  text-sm text-left font-normal relative">
                                    <button
                                      className="text-indigo-500"
                                      type="button"
                                      onClick={() => {
                                        onUpdate(
                                          school.schoolId,
                                          school.nweaId
                                        );
                                      }}
                                    >
                                      Map
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {schools.length === 0 && (
                            <p className="p-2">No Records Found</p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between items-center">
                      <Pagination
                        pages={totalPages}
                        setPageNumber={setPageNumber}
                        ref={paginationRef}
                      />
                      <span>
                        <span className="text-sm pr-4 ml-auto text-left-700">
                          Showing {pageNumber} to{" "}
                          {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                          {totalRecords} results{" "}
                        </span>

                        <SelectPageSize
                          setPageSize={setPageSize}
                          type={"second"}
                          ref={pageSizeRef}
                        />
                      </span>
                    </div>
                  </div>
                </div>

                <footer className="flex justify-end mt-8 items-center border-t ">
                  <button
                    className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                    onClick={closeSchoolModal}
                  >
                    Close
                  </button>
                </footer>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SchoolPupUp;
